import {Component, computed, inject, input, Input} from '@angular/core';
import {Router} from '@angular/router';
import {ClientStore} from '../../../core/states/clientes-state/client-state.store';

@Component({
  selector: 'app-title-pages-component',
  standalone: true,
  imports: [],
  templateUrl: './title-pages-component.html',
  styleUrl: './title-pages-component.scss',
})
export class TitlePagesComponent {
  private router = inject(Router);
  private store = inject(ClientStore);

  @Input() pageData!: { title: string,  subTitle: string };
  @Input() showDivider = true;
  showClientName = input<boolean | null>(false);

  protected clientName = computed(() =>
    this.showClientName() ? this.store.client()?.name ?? null : null
  );

  showMenu: boolean = false;

  toggleMenu() {
    this.showMenu = !this.showMenu;
  }

  goToClients(){
    this.router.navigate(['/clientes'])
  }

}
